import { useState } from "react";
import { InfoIcon } from "../../assets/icons/icons";
import { useConfig } from "../../contexts/ConfigContext";
import PieChart from "../Charts/PieChart";
import CategoryInfoModal from "./CategoryInfoModal";
import "./category.css";

const CategoryScore = ({ categoryData, onExpand }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const { config } = useConfig();

  return (
    <>
      <div className="category-tile">
        <div className="tile-left">
          <h3 className="category-title">
            {categoryData.category_name}
            <InfoIcon className="info-icon" onClick={toggleModal} />
          </h3>
          <button className="expand-btn" onClick={onExpand}>
            More Info
          </button>
        </div>

        <div className="tile-right">
          <PieChart
            gradeBreakdown={categoryData.grade_breakdown}
            avgScore={categoryData.avg_score}
            avgGrade={categoryData.avg_grade}
            gradeScale={config.gradeScale}
          />
        </div>
      </div>

      <CategoryInfoModal
        isOpen={isModalOpen}
        closeModal={toggleModal}
        data={categoryData.category_description}
      />
    </>
  );
};

export default CategoryScore;